import {
  Checkbox,
  FormControlLabel,
  ListItemText,
  Stack,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import {useThemeContext} from "@theme";
import {translate} from "@util";

type FilterGroupProps = {
  title: string;
  ids: string[];
  sx?: SxProps<Theme>;
  isChecked: (id: string) => boolean;
  count: (id: string) => number;
  renderLabel: (id: string) => React.ReactNode;
  onChange: (id: string, checked: boolean) => void;
  onChangeAll: (ids: string[], checked: boolean) => void;
};

const FilterGroup = ({
  title,
  ids,
  sx,
  isChecked,
  count,
  renderLabel,
  onChange,
  onChangeAll,
}: FilterGroupProps) => {
  const {onPrimary} = useThemeContext();
  return (
    <Stack sx={sx}>
      <Typography
        variant="subtitle2"
        sx={{
          textAlign: "center",
          bgcolor: "primary.dark",
          p: 1,
          color: onPrimary,
        }}>
        {title}
      </Typography>
      <Stack px={1}>
        {ids.length > 0 && (
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={ids.every(isChecked)}
                indeterminate={ids.some(isChecked) && !ids.every(isChecked)}
                onChange={(_, checked) => onChangeAll(ids, checked)}
              />
            }
            label={
              <Typography variant="body2">
                {translate("common.label.all")}
              </Typography>
            }
            labelPlacement="start"
            sx={{ml: 0, justifyContent: "space-between"}}
          />
        )}
        {ids.map(id => (
          <FormControlLabel
            key={`task-filter-${id}`}
            control={
              <Checkbox
                size="small"
                checked={isChecked(id)}
                onChange={(_, checked) => onChange(id, checked)}
              />
            }
            label={
              <Stack direction="row" alignItems="center" gap={0.5}>
                {renderLabel(id)}
                <Typography variant="body2">({count(id)})</Typography>
              </Stack>
            }
            labelPlacement="start"
            sx={{ml: 0, justifyContent: "space-between"}}
          />
        ))}
        {ids.length === 0 && <ListItemText secondary="-" />}
      </Stack>
    </Stack>
  );
};

export {FilterGroup};
